import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const panWildfire = defineConnector({
  identifier: "panWildfire",
  name: "PAN WildFire",
  tagLine: "Cloud-based malware analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*wildfire\\.paloaltonetworks\\.com/.*",
  auth: customAuth("panWildfire"),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the WildFire portal, go to **Account > API Keys** to retrieve your API key.",
        },
      ],
    },
    {
      title: "Enter your WildFire details",
      items: [
        {
          kind: "select",
          label: "Cloud",
          required: true,
          target: { kind: "configuration", field: "cloud" },
          options: [
            { value: "wildfire.paloaltonetworks.com", label: "Global (US)" },
            { value: "eu.wildfire.paloaltonetworks.com", label: "EU" },
            { value: "jp.wildfire.paloaltonetworks.com", label: "Japan" },
          ],
          helperText: "The WildFire cloud region for your account.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ cloud }) => ({
      url: `https://${cloud}/publicapi/test/pe`,
      method: "POST",
    }),
  },
});
